import { Box } from "@mui/material";
import { DotLegalButton, DotLegalMultiSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { SelectableColoredItem } from "../../processingActivity/ProcessingActivity.types";
import { useCreateExternalUserInlineForm } from "./CreateExternalUserInlineForm.hooks";

export interface CreatedExternalUser {
    id: string;
    name: string;
    email: string;
    businessAreas: Array<SelectableColoredItem>;
}

export interface ICreateExternalUserInlineFormProps {
    existingEmails: Array<string>;
    onCreated: (created: CreatedExternalUser) => void;
}

function CreateExternalUserInlineForm(props: ICreateExternalUserInlineFormProps) {
    const { translateString } = useTranslation();
    const {
        name,
        setName,
        email,
        setEmail,
        businessAreas,
        setBusinessAreas,
        businessAreaOptions,
        isLoadingBusinessAreas,
        emailErrorText,
        canCreate,
        create,
        isCreating,
    } = useCreateExternalUserInlineForm(props);

    // The fields keep their own bottom margin instead of being spaced by a flex gap, so they sit on the same
    // rhythm as the surrounding dialog fields rather than bunching together.
    return (
        <Box>
            <DotLegalTextField label={translateString("name")} value={name} onChange={setName} debounce={false} size="small" />
            <DotLegalTextField
                label={translateString("recipientEmail")}
                value={email}
                onChange={setEmail}
                errorText={emailErrorText}
                debounce={false}
                size="small"
            />
            <DotLegalMultiSelect
                label={translateString("businessAreas")}
                options={businessAreaOptions}
                chosenOptions={businessAreas}
                onChange={setBusinessAreas}
                isLoading={isLoadingBusinessAreas}
                noOptionsLabel={translateString("noOptions")}
            />
            <DotLegalButton buttonType="secondary" size="small" disabled={!canCreate} isLoading={isCreating} onClick={create}>
                {translateString("add")}
            </DotLegalButton>
        </Box>
    );
}

export default CreateExternalUserInlineForm;
